var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.553 0.594238H0.552734V250.594H250.553V0.594238Z",
    fill: "current",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.489 195.908C173.525 204.13 180.076 210.174 191.664 210.174C201.398 210.174 207.616 205.309 207.616 198.586C207.616 190.531 201.227 187.678 190.513 182.991L184.64 180.471C167.687 173.249 156.426 164.201 156.426 145.074C156.426 127.455 169.85 114.043 190.83 114.043C205.767 114.043 216.505 119.241 224.243 132.852L205.949 144.598C201.922 137.376 197.576 134.531 190.83 134.531C183.949 134.531 179.588 138.896 179.588 144.598C179.588 151.646 183.953 154.499 194.033 158.864L199.906 161.38C219.866 169.94 231.136 178.666 231.136 198.285C231.136 219.436 214.521 231.023 192.207 231.023C170.39 231.023 156.295 220.626 149.398 206.999L168.489 195.908ZM85.5009 197.944C89.1914 204.491 92.5486 210.027 100.62 210.027C108.338 210.027 113.207 207.007 113.207 195.265V115.384H136.699V195.582C136.699 219.908 122.437 230.979 101.62 230.979C82.8105 230.979 71.9176 221.245 66.3779 209.521L85.5009 197.944Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsJs);
export default __webpack_public_path__ + "static/media/skills-js.29e4479bc961d27768eab91cd4a36df8.svg";
export { ForwardRef as ReactComponent };